import React from 'react';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-dark text-off-white p-8">
          <div className="text-center space-y-4">
            <h1 className="font-display text-3xl font-semibold">Oups, une erreur est survenue</h1>
            <p className="text-grey">Veuillez rafraîchir la page.</p>
            <button
              onClick={() => window.location.reload()}
              className="mt-4 px-6 py-2 rounded-full bg-rose text-dark font-medium"
            >
              Rafraîchir
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
